import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormArray, FormGroup, FormBuilder } from '@angular/forms';

export interface TermsPolicy {
  id: number;
  name: string;
  text: string;
}

@Component({
  selector: 'app-cash-payment-acknowledgment',
  templateUrl: './cash-payment-acknowledgment.component.html',
  styleUrls: ['./cash-payment-acknowledgment.component.scss']
})
export class CashPaymentAcknowledgmentComponent implements OnInit {
  @Output() public submitButtonStateChanged = new EventEmitter<boolean>();

  public form!: FormGroup;
  public getCheckboxStatus: boolean = false;
  public termsAndPolicy: TermsPolicy[] = [
    {
      id: 1,
      name: "option1",
      text: "I understand it is our Company's responsibility to pay our seller participants based on the amounts they claim in the Seller Rewards platform.",
    },
    {
      id: 2,
      name: "option2",
      text: "I understand that all rewards (cash, points, and prizes) claimed by sellers are earned on behalf of our company. Our Company is therefore responsible for and must pay and withhold all applicable income, federal, state, provincial taxes, social security, national insurance contributions, social charge or other taxes.",
    },
    {
      id: 3,
      name: "option3",
      text: "I understand that our Company must provide acknowledgement to Cisco within 45 days of cash receipt that payment to sellers was completed. Failure to do so may result in loss of access to the Seller Rewards incentive.",
    },
    {
      id: 4,
      name: "option4",
      text: "I understand there may be delays in payment timing.",
    },
    {
      id: 5,
      name: "option5",
      text: "I understand that the designated Company rebate/payment coordinator must claim payments from Cisco within 90 days, or payments may be forfeited.",
    },
  ];

  constructor(private formBuilder: FormBuilder) {}

  public ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    const checkboxesArray = this.formBuilder.array(
      this.termsAndPolicy.map(() => this.formBuilder.control(false))
    );

    this.form = this.formBuilder.group({
      checkBoxes: checkboxesArray,
      signatureName: [''],
    });
  }

  public areAllCheckboxesChecked(): void {
    const checkboxesArray = this.form.get('checkBoxes') as FormArray;

    this.getCheckboxStatus = checkboxesArray.controls.every(
      (control) => control.value
    );
    const signatureControl = this.form.get('signatureName');
    const signatureName = (signatureControl != null) ? signatureControl.value.trim() : '';
    const isSubmitDisabled = !(this.getCheckboxStatus && signatureName.length > 0);
    this.submitButtonStateChanged.emit(isSubmitDisabled);
  }

  public onChangeInput(): void {
    const checkboxesArray = this.form.get('checkBoxes') as FormArray;
    this.getCheckboxStatus = checkboxesArray.controls.every(
      (control) => control.value
    );
    const signatureControl = this.form.get('signatureName');
    const signatureName = (signatureControl != null) ? signatureControl.value.trim() : '';
    const isSubmitDisabled = !(this.getCheckboxStatus && signatureName.length > 0);
    this.submitButtonStateChanged.emit(isSubmitDisabled);
  }
}
